import React from 'react';

import { Segmented } from '../../components/ui';

const TAX_RATE_OPTIONS = [
  { value: 'margin_scheme', label: 'Margin scheme' },
  { value: 'vat', label: 'VAT' },
];

export function TaxRate({
  taxRate,
  setTaxRate,
}) {
  // Same semantics as the switch it replaces: anything but 'vat' reads as
  // margin scheme, and only a real change calls setTaxRate.
  const current = taxRate === 'vat' ? 'vat' : 'margin_scheme';

  return (
    <div className="col-12 col-lg-6">
      <div className="strong-label tax-rate-label">
        Tax Rate
      </div>

      <div className="tax-rate-row">
        <Segmented
          label="Tax rate"
          options={TAX_RATE_OPTIONS}
          value={current}
          onChange={(next) => next !== current && setTaxRate(next)}
        />
      </div>
    </div>
  );
}
